import React from 'react';

/**
 * Subtle mono-caption link with a ↗ glyph — the standard "view evidence"
 * affordance so every displayed fact can reach its source in one interaction.
 * Renders an <a>; pass href, or onClick for in-app evidence drawers.
 */
export function EvidenceLink({ href, children = 'View evidence', className = '', ...rest }) {
  return (
    <a
      href={href}
      className={['opt-evidence-link', className].filter(Boolean).join(' ')}
      {...rest}
    >
      <span>{children}</span>
      <span className="opt-evidence-link__icon" aria-hidden="true">
        ↗
      </span>
    </a>
  );
}

export default EvidenceLink;
